import Vue from 'vue'
import '../../plugins/axios'
import '../../plugins/machine'
import App from './App.vue'
import i18n from '@/plugins/i18n'

import Logger from '@/plugins/logger'
import '@/plugins/polyfill-object-fromentries'
import useIEHelper from '@/commons/ie-helper'
import useLanguageTree from '@/commons/language.js'
import loadWhitelabel from '@/commons/whitelabel.js'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
const { URLSearchParamsWrapper } = useIEHelper()
const { t } = useLanguageTree()

Vue.prototype.$tf = t

Vue.use(Logger, { level: 8 })

Vue.config.productionTip = false
let urlParams = URLSearchParamsWrapper(window.location.search)
Vue.prototype.$wlDomain = decodeURIComponent(urlParams.get('wl') || '')
loadWhitelabel(Vue.prototype.$wlDomain).then(res => {
  const vuetify = res.vuetify
  Vue.prototype.$headerLogo = res.headerLogo
  Vue.prototype.$wlURL = res.whitelabelURL
  Vue.use(vuetify)
  const app = new Vue({
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount('#app')

  if (process.env.NODE_ENV === 'development' && window) {
    window.app = app
    window.Vue = Vue
  }
})
